export enum ErrorSubcode {
  MISSING_FIELD = 'MISSING_FIELD',
  INVALID_FORMAT = 'INVALID_FORMAT',
  INVALID_VALUE = 'INVALID_VALUE',
  TOO_LONG = 'TOO_LONG',
  TOO_SHORT = 'TOO_SHORT',
  INVALID_TYPE = 'INVALID_TYPE',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INVALID_EMAIL_DOMAIN = 'INVALID_EMAIL_DOMAIN',

  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  PASSWORD_BREACHED = 'PASSWORD_BREACHED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  SESSION_INVALID = 'SESSION_INVALID',

  NOT_FOUND = 'NOT_FOUND',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  CONFLICT = 'CONFLICT',
  RESOURCE_LIMIT = 'RESOURCE_LIMIT',

  OPERATION_FAILED = 'OPERATION_FAILED',
  INVALID_STATE = 'INVALID_STATE',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',

  // Mapped in the app rather than read off an error body: agent-service reports
  // a deliverable chat turn that ended without saying how it settled as the
  // `reason` on an SSE `error` frame, and `errorFromEventFrame` turns that
  // reason into this subcode. It is its own member so the copy lives in the
  // `deliverables` feature block without shadowing a subcode the backend does
  // send there.
  NO_TURN_OUTCOME = 'NO_TURN_OUTCOME',

  EXTERNAL_SERVICE_ERROR = 'EXTERNAL_SERVICE_ERROR',
  /**
   * An OAuth provider rejected the authorization code (`invalid_grant`).
   * Always recoverable by connecting again, so surface a retry rather than
   * a dead end.
   */
  OAUTH_GRANT_INVALID = 'OAUTH_GRANT_INVALID',
  /**
   * OAuth consent finished without every permission the integration needs, so
   * nothing was connected. The response's `details.missingPermissions` lists
   * what the user must grant; see `getMissingPermissions`.
   */
  INTEGRATION_PERMISSIONS_MISSING = 'INTEGRATION_PERMISSIONS_MISSING',
  TIMEOUT = 'TIMEOUT',
  RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',

  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}
